// extracted by mini-css-extract-plugin
export default {"time_box":"Electricity_time_box__PNMlc","time_label":"Electricity_time_label__mr8tz","chart_wrapper":"Electricity_chart_wrapper__OJzUX"};